import {
  Link,
  Stack,
  ViewHeader,
  ViewItemField,
  ViewItemFieldWithChildren,
} from '@fukuri-admins/ui/common';

type Props = {
  /** タイトルに表示する利用企業名（"{clientName}の契約期間" の形式） */
  clientName: string;
  /**
   * 編集画面への遷移パス
   *
   * - `undefined` のとき編集ボタンを表示しない（enableStaging が false の環境）
   */
  editLink?: string;
  /** 契約プラン名 */
  contractPlanName: string;
  /** 契約プラン詳細画面への遷移パス */
  contractPlanLink: string;
  /** 開始日（例: 「2024/08/01」） */
  startedOnLabel: string;
  /**
   * 終了日（例: 「2024/12/31」）
   *
   * - 無期限（ended_on が null）の場合は空文字列を渡す → 空欄表示
   */
  endedOnLabel: string;
  /** 作成日時ラベル（例: 「2024/08/01 10:30」） */
  createdAtLabel: string;
  /** 更新日時ラベル（例: 「2024/08/01 10:30」） */
  updatedAtLabel: string;
};

/**
 * 企業契約期間 詳細 Presentation
 *
 * 詳細 body を表示する（Figma: node-id 24274-27424）。
 * - TitleWrapper: タイトル（{clientName}の契約期間）＋ 編集ボタン（editLink がある場合のみ）
 * - 各フィールド: 契約プラン（リンク） / 開始日 / 終了日 / 作成日時 / 更新日時
 *
 * 編集ボタンの表示可否は Container 側の `enableStaging` 判定に従う（`editLink` が
 * `undefined` なら ViewHeader 側で非表示になる）。
 */
export const ClientContractTermDetailPresentation: React.FC<Props> = ({
  clientName,
  editLink,
  contractPlanName,
  contractPlanLink,
  startedOnLabel,
  endedOnLabel,
  createdAtLabel,
  updatedAtLabel,
}) => (
  <Stack gap={24}>
    <ViewHeader title={`${clientName}の契約期間`} editLink={editLink} />
    <Stack gap={24}>
      <ViewItemFieldWithChildren label='契約プラン' direction='row'>
        <Link to={contractPlanLink} isExternal target='_blank'>
          {contractPlanName}
        </Link>
      </ViewItemFieldWithChildren>
      <ViewItemField label='開始日' direction='row' value={startedOnLabel} />
      <ViewItemField label='終了日' direction='row' value={endedOnLabel} />
      <ViewItemField label='作成日時' direction='row' value={createdAtLabel} />
      <ViewItemField label='更新日時' direction='row' value={updatedAtLabel} />
    </Stack>
  </Stack>
);
